import { useEffect, useState } from 'react'

const webPushPublicKey = import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY

export const useSupported = () => {
  const [isSupported, setSupported] = useState(false)
  const [isNotificationSupported, setNotificationSupported] = useState(false)

  useEffect(() => {
    const checkSupport = () => {
      if (!!webPushPublicKey && 'serviceWorker' in navigator) {
        setSupported(true)
        setNotificationSupported(
          'Notification' in window && 'PushManager' in window,
        )
      } else {
        setSupported(false)
        setNotificationSupported(false)
      }
    }

    checkSupport()
  }, [])

  return {
    isSupported,
    isNotificationSupported,
    publicKey: webPushPublicKey,
  }
}
